import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE } from 'ducks/slice';

import { modal_default } from './defaults';
import { Modal, ModalClear, ModalUpdate } from './types';
import { clearModalState, updateModalState } from './utils';

const initialState: Modal = modal_default;

export const modalsSlice = createSlice({
  name: SLICE.MODALS,
  initialState,
  reducers: {
    updateModal: {
      reducer: (state: Modal, action: PayloadAction<ModalUpdate>) => {
        return updateModalState(state, action.payload.key, action.payload.data);
      },
      prepare: <K extends keyof Modal>(payload: ModalUpdate<K>) => ({ payload }),
    },
    clearModal: {
      reducer: (state: Modal, action: PayloadAction<ModalClear>) => {
        return clearModalState(state, action.payload);
      },
      prepare: (payload: ModalClear) => ({ payload }),
    },
    clearModals: () => {
      return initialState;
    },
  },
});

export const { updateModal, clearModal, clearModals } = modalsSlice.actions;

export default modalsSlice.reducer;
